import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LuArrowLeft } from 'react-icons/lu'

// The old hand-rolled BackArrow baked in `var(--color-gray-600)` — a token this app
// never defines — so the glyph fell back to black and ignored the theme. Lucide at 18
// inherits currentColor from the button instead.
const BackButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex items-center gap-2 mb-2 text-sm text-text-secondary hover:text-text-primary cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main rounded transition-colors"
  >
    <LuArrowLeft size={18} />
    <span>Back</span>
  </button>
)

// `useNavigate` lives in its own component so PageTitle itself never requires a Router
// context — pages that pass `onBack` (or no back control at all) render standalone.
const BackToButton = ({ to }) => {
  const navigate = useNavigate()

  return <BackButton onClick={() => navigate(to)} />
}

// `onBack` (a callback, e.g. `() => navigate(-1)`) and `backTo` (a route to push) both
// render the back control on its own row *above* the heading rather than inline before
// it. Inline, the arrow pushed the title ~32px to the right, so pages that had one
// (onboarding, edit user, edit customer) sat out of line with every other page title.
// `subtitle` carries the identity of the record being edited. Without it every
// edit screen just said "Edit User", so with two tabs open you could not tell
// which person you were about to save over.
const PageTitle = ({ title, subtitle, onBack, backTo }) => {

  return (
    <div className="pb-7 min-w-0">
      {onBack ? <BackButton onClick={onBack} /> : backTo ? <BackToButton to={backTo} /> : null}
      <h1 className="text-xl font-semibold font-sans text-text-primary">{title}</h1>
      {subtitle && (
        <p className="mt-1 text-md text-text-secondary truncate">{subtitle}</p>
      )}
    </div>
  )
}
export default PageTitle
